import { render, staticRenderFns } from "./versionDisplay.vue?vue&type=template&id=3ad084da"
import script from "./versionDisplay.vue?vue&type=script&lang=js"
export * from "./versionDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports